<template>
  <transition @leave="leaveLS">
    <div v-if="!fullyLoaded" class="loader">
      <div class="loader__progress-bar" :style="{height: loadingPercent + '%'}"></div>
      <span class="text-wrap">
        <span :style="{position: 'absolute', visibility: 'hidden'}" class="loader__text">Loading</span>
        <transition mode="out-in" appear @appear="enterText" @enter="enterText" @leave="leaveText">
          <span v-if="loadingPercent < 100" :key="'loading'" class="loader__text">{{ loaded }}</span>
          <span v-if="loadingPercent >= 100" :key="'loaded'" class="loader__text">Hello.</span>
        </transition>
      </span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoadingScreen",
  data() {
    return {
      loadingPercent: 0,
      loadTime: 0,
      interval: null,
      fullyLoaded: true
    };
  },
  methods: {
    doProgress() {
      let step = this.loadTime / 100;
      this.interval = setInterval(() => {
        this.loadingPercent++;
        this.loadingPercent >= 100
          ? setTimeout(() => {
              // this.loadingPercent = 200;
              this.fullyLoaded = true;
              this.$emit("disableScrollMenu", false);
            }, 2500)
          : (this.fullyLoaded = false);
        this.$emit("disableScrollMenu", true);
      }, step);
    },
    enterText: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          bottom: "-200px"
        },
        {
          bottom: "0",
          ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
          onComplete: done
        }
      );
    },
    leaveText: function(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          bottom: "0px"
        },
        {
          bottom: "200px",
          ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
          onComplete: done
          // delay: 1
        }
      );
    },
    leaveLS: function(el, done) {
      TweenMax.to(el, 2, {
        y: "-100%",
        ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),    
        delay: .3,
        onComplete: done
      });

      // TweenMax.to(".loader .text-wrap", 1.8, {
        // y: "500%"
      // });

      TweenMax.fromTo(
        ".loader__text",
        1,
        {
          bottom: "0px"
        },
        {
          ease: CustomEase.create("custom", "M0,0 C0.77,0 0.175,1 1,1"),
          bottom: "200px"
          // delay: .6
        }
      );
    }
  },
  created() {
    let perfData = window.performance.timing;
    let estimatedTime = Math.abs(
      perfData.loadEventEnd - perfData.navigationStart
    );
    this.loadTime = parseInt((estimatedTime / 1000) % 60) * 100;
    this.doProgress();
  },
  computed: {
    loaded() {
      return this.loadingPercent + "%";
    }
  },
  watch: {
    loadingPercent(val) {
      if (val >= 100) {
        clearInterval(this.interval);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/LoadingScreen.vue